var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburgerClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.914 0.632629C11.1621 0.632629 8.47193 1.44867 6.18379 2.97756C3.89565 4.50644 2.11226 6.67951 1.05914 9.22195C0.00602884 11.7644 -0.269514 14.562 0.267359 17.2611C0.804233 19.9601 2.12941 22.4394 4.07531 24.3853C6.02122 26.3312 8.50045 27.6563 11.1995 28.1932C13.8985 28.7301 16.6962 28.4545 19.2386 27.4014C21.7811 26.3483 23.9541 24.5649 25.483 22.2768C27.0119 19.9886 27.8279 17.2985 27.8279 14.5466C27.8279 10.8564 26.362 7.31731 23.7526 4.70794C21.1433 2.09856 17.6042 0.632629 13.914 0.632629ZM19.8135 19.1846L18.552 20.4461L13.914 15.8545L9.32237 20.4461L8.01445 19.1846L12.6061 14.5466L8.01445 9.95499L9.32237 8.64708L13.914 13.2387L18.552 8.64708L19.8599 9.95499L15.2219 14.5466L19.8135 19.1846Z",
    fill: "#AFAFAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerClose);
export default __webpack_public_path__ + "static/media/hamburgerClose.8ac20780401dd13e312052bc7ce5c536.svg";
export { ForwardRef as ReactComponent };